exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ms-Dialog-main._3UkyJx4jrvIzBZo3UFSoqU{min-width:600px}.NjyfzwqIK0TUkYJu4t3-Q{width:100%}._3KRz2uZDDp386IVbce-7pV{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.k6CC3J3UX9hr1vy2UUpBn{min-width:250px;width:100%}html[dir] .k6CC3J3UX9hr1vy2UUpBn{margin:5px 0}", ""]);
// Exports
exports.locals = {
	"linkDialog": "_3UkyJx4jrvIzBZo3UFSoqU",
	"linkContent": "NjyfzwqIK0TUkYJu4t3-Q",
	"linkLabel": "_3KRz2uZDDp386IVbce-7pV",
	"linkInput": "k6CC3J3UX9hr1vy2UUpBn"
};